import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
import {
  accessApi,
  apiPortal,
  apiDPA,
  responseApi,
  toEncrypt,
} from "@/provider";
import { apiMsg } from "../provider";
// import { toEncrypt } from "../provider";
const ls = new SecureLS({ isCompression: false });

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    inboxFitur: true,
    redeemFitur: false,
    storeFitur: true,
    bannerFitur: true,
    isLoading: true,
    user: null,
    preUser: null,
    profile: null,
    popupShow: false,
    token: null,
    promo: null,
    pid: null,
    mno_id: null,
    selectedPlan: null,
    transactionId: null,
    url: null,
    listgame: [],
    detailgame: {},
    dr: [],
    tokenLife: null,
    statusStore: false,
    gameId: null,
    gameIdUnix: null,
    coin: 0,
    point: 0,
    android: false,
    cellcardFramePotrait: false,
    dataPoint: [],
    reward: null,
    playerData: {},
    sessionUser: null,
    mode: "reg", // mode reg and free
    leaderboardList: [
      // {
      //   msisdn: "62812345xxxx",
      //   point: "10000"
      // },
      // {
      //   msisdn: "62812111xxxx",
      //   point: "9000"
      // },
      // {
      //   msisdn: "62822443xxxx",
      //   point: "8000"
      // },
      // {
      //   msisdn: "62812645xxxx",
      //   point: "7000"
      // },
      // {
      //   msisdn: "62822349xxxx",
      //   point: "6000"
      // },
      // {
      //   msisdn: "62822340xxxx",
      //   point: "5000"
      // },
      // {
      //   msisdn: "62811340xxxx",
      //   point: "4500"
      // },
      // {
      //   msisdn: "62812040xxxx",
      //   point: "3000"
      // },
      // {
      //   msisdn: "62822390xxxx",
      //   point: "2500"
      // },
      // {
      //   msisdn: "62811140xxxx",
      //   point: "1000"
      // },
    ],
    popupReward: [
      {
        point: "25",
        image: require("@/assets/hadiah-1gb.png"),
        title: "Selamat!",
        description:
          "Kamu dapat hadiah langsung paket Data 1GB! Ambil hadiahnya sekarang!",
      },
      {
        point: "26",
        image: require("@/assets/hadiah-100rb.png"),
        title: "Selamat!",
        description:
          "Kamu dapat hadiah langsung Uang Tunai 100 ribu! Ambil hadiahnya sekarang!",
      },
      {
        point: "27",
        image: require("@/assets/hadiah-500rb.png"),
        title: "Selamat!",
        description:
          "Kamu dapat hadiah langsung Uang Tunai 500 ribu! Ambil hadiahnya sekarang!",
      },
      {
        point: "28",
        image: require("@/assets/hadiah-1jt.png"),
        title: "Selamat!",
        description:
          "Kamu dapat hadiah langsung Uang Tunai 1 juta! Ambil hadiahnya sekarang!",
      },
      {
        point: "29",
        image: require("@/assets/hadiah-1.5jt.png"),
        title: "Selamat!",
        description:
          "Kamu dapat hadiah langsung Uang Tunai 1,5 juta! Ambil hadiahnya sekarang!",
      },
      {
        point: "30",
        image: require("@/assets/hadiah-2jt.png"),
        title: "Selamat!",
        description:
          "Kamu dapat hadiah langsung Uang Tunai 2 juta! Ambil hadiahnya sekarang!",
      },
    ],
    inboxList: [
      {
        id: 1,
        name: "Info",
        image: "",
        created: "2021/05/01",
        description:
          "Selamat Datang di 3ple Hoki game. Mainkan terus gamenya dan dapatkan banyak hadiah menarik untuk kamu",
        url: "#",
      },
    ],
    storeList: [],
    popupToken: {
      point: null,
      image: require("@/assets/token-null.png"),
      title: "Token Tidak Cukup!",
      description:
        "Yaah, tokenmu tidak cukup untuk main game ini. Tambah dulu yuk tokenmu!",
    },
    popupLogout: {
      point: null,
      // image: require("@/assets/token-null.png"),
      title: {
        id: "Are you sure you want to logout?",
        en: "Are you sure you want to logout?",
        km: "តើអ្នកពិតជាចង់ចាកចេញមែនទេ?",
      },

      description: {
        id: "You will need to sign in again to access your account",
        en: "You will need to sign in again to access your account",
        km: "អ្នកតម្រូវឱ្យចូលគណនីម្ដងទៀត ដើម្បីអាចចូលប្រើប្រាស់បាន។",
      },

      button: {
        id: "Log Out",
        en: "Log Out",
        km: "ចាកចេញ",
      },

      buttonCancel: {
        id: "Cancel",
        en: "Cancel",
        km: "បោះបង់",
      },
    },
    popupSubscription: {
      point: null,
      image: require("@/assets/token-null.png"),

      title: {
        id: "Belum Berlangganan!",
        en: "Not Subscribed!",
        km: "មិនទាន់បានភ្ជាប់",
      },

      description: {
        id: "Berlangganan dulu untuk mulai bermain game ini.",
        en: "Subscribe to start playing this game.",
        km: "សូមភ្ជាប់ជាមុន ដើម្បីចាប់ផ្តើមលេងហ្គេមនេះ។",
      },

      button: {
        id: "Berlangganan Sekarang",
        en: "Subscribe Now",
        km: "ចុចភ្ជាប់",
      },

      buttonOk: {
        en: "Ok",
        km: "យល់ព្រម",
      },
    },
    // appKey: 'eyJhcHBfYWxpYXMiOiJib2xhaG9raSIsImFwcF9uYW1lIjoiQm9sYSBIb2tpIiwiY3BfaWQiOjV9H65W3CcggO2UZtCM4s7Cp8qN',
    appKey:
      "eyJhcHBfYWxpYXMiOiJib2xhaG9raSIsImFwcF9uYW1lIjoiQm9sYSBIb2tpIiwiY3BfaWQiOjV9H65W3CcggO2UZtCM4s7Cp8qN",
    // appKey: 'eyJhcHBfYWxpYXMiOiJwb3J0YWxIdXRjaCIsImFwcF9uYW1lIjoiUG9ydGFsIEh1dGNoIiwiY3BfaWQiOjV9pNNpr46aKHSUOS4T',
    secretKey: "Bismillah",
    telco: null,
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
  getters: {
    isUser: (state) => state.user,
    getUser: (state) => state.user,
    getPreUser: (state) => state.preUser,
    getSecret: (state) => state.secretKey,
    getGameId: (state) => state.gameId,
    getLifeId: (state) => state.tokenLife,
    getCoin: (state) => state.coin,
    getMode: (state) => state.mode,
    getRedeem: (state) => state.redeemList,
    getStore: (state) => state.storeList,
    getDR: (state) => state.dr,
    getBanner: (state) => state.bannerList,
    getInbox: (state) => state.inboxList,
    getPid: (state) => state.pid,
    getReward: (state) => state.popupReward,
    getLeaderboard: (state) => state.leaderboardList,
    getGameIdUnix: (state) => state.gameIdUnix,
    getAppkey: (state) => state.appKey,
    getPopupShow: (state) => state.popupShow,
    getTelco: (state) => state.telco,
    getSessionUser: (state) => state.sessionUser,
  },
  mutations: {
    SET_TOKEN: (state, value) =>
      value ? (state.token = value) : (state.token = null),
    SET_USER: (state, value) =>
      value ? (state.user = value) : (state.user = null),
    SET_PRE_USER: (state, value) =>
      value ? (state.preUser = value) : (state.preUser = null),
    SET_URL: (state, value) =>
      value ? (state.url = value) : (state.url = null),
    SET_LIST_GAME: (state, value) =>
      value ? (state.listgame = value) : (state.listgame = []),
    SET_PROFILE: (state, value) =>
      value ? (state.profile = value) : (state.profile = null),
    SET_PROMO: (state, value) =>
      value ? (state.promo = value) : (state.promo = null),
    SET_TOKEN_LIFE: (state, value) =>
      value ? (state.tokenLife = value) : (state.tokenLife = null),
    SET_DATA_POINT: (state, value) =>
      value ? (state.dataPoint = value) : (state.dataPoint = []),
    SET_GAME_ID: (state, value) =>
      value ? (state.gameId = value) : (state.gameId = null),
    SET_DETAIL_GAME: (state, value) =>
      value ? (state.detailgame = value) : (state.detailgame = {}),
    SET_COIN: (state, value) =>
      value ? (state.coin = value) : (state.coin = 0),
    SET_POINT: (state, value) =>
      value ? (state.point = value) : (state.point = 0),
    SET_REWARD: (state, value) =>
      value ? (state.reward = value) : (state.reward = null),
    SET_MODE: (state, value) =>
      value ? (state.mode = value) : (state.mode = "free"),
    SET_TELCO: (state, value) =>
      value ? (state.telco = value) : (state.telco = null),
    SET_BANNER_LIST: (state, value) =>
      value ? (state.bannerList = value) : (state.bannerList = []),
    SET_REWARD_LIST: (state, value) =>
      value ? (state.popupReward = value) : (state.popupReward = []),
    SET_STORE_LIST: (state, value) =>
      value ? (state.storeList = value) : (state.storeList = []),
    SET_DELIVER_RECHIVE: (state, value) =>
      value ? (state.dr = value) : (state.dr = []),
    SET_LEADERBOARD_LIST: (state, value) =>
      value ? (state.leaderboardList = value) : (state.leaderboardList = []),
    SET_INBOX_LIST: (state, value) =>
      value ? (state.inboxList = value) : (state.inboxList = []),
    SET_GAME_ID_UNIX: (state, value) =>
      value ? (state.gameIdUnix = value) : (state.gameIdUnix = null),
    SET_GAME_POPUP_SHOW: (state, value) =>
      value ? (state.popupShow = value) : (state.popupShow = false),
    SET_PLAYER_DATA: (state, value) =>
      value ? (state.playerData = value) : (state.playerData = {}),
    SET_MNO_ID: (state, value) =>
      value ? (state.mno_id = value) : (state.mno_id = null),
    SET_SELECTED_PLAN: (state, value) =>
      value ? (state.selectedPlan = value) : (state.selectedPlan = null),
    SET_TRANSACTION_ID: (state, value) =>
      value ? (state.transactionId = value) : (state.transactionId = null),
    SET_SESSION_USER: (state, value) =>
      value ? (state.sessionUser = value) : (state.sessionUser = null),
  },
  actions: {
    getProfile: ({ commit, getters }) => {
      return new Promise((resolve, reject) => {
        accessApi()
          .then(async (token) => {
            const msisdn = toEncrypt(getters.getUser, getters.getSecret);
            const sendData = { req: msisdn };
            const headers = { Authorization: `bearer ${token}` };
            const { data } = await apiPortal.post("gameProfile", sendData, {
              headers,
            });
            const dataProfile = await JSON.parse(responseApi(data));
            const JsonDataProfile = dataProfile;
            commit("SET_TELCO", JsonDataProfile.telco);
            commit("SET_PROFILE", JsonDataProfile);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getDetail: ({ commit, getters }) => {
      return new Promise((resolve, reject) => {
        accessApi()
          .then(async (token) => {
            const msisdn = toEncrypt(getters.getUser, getters.getSecret);
            const sendData = { req: msisdn };
            const headers = { Authorization: `bearer ${token}` };
            const [detailResponse, playerResponse] = await Promise.all([
              apiPortal.post("gameDetail", sendData, { headers }),
              apiPortal.get("getPlayerAppData", { headers }),
            ]);
            const data = detailResponse.data;
            const playerData = playerResponse.data.data || {};
            const dataDetail = await JSON.parse(responseApi(data));
            const JsonDataDetail = dataDetail;
            commit("SET_PLAYER_DATA", playerData);
            commit("SET_COIN", JsonDataDetail.token);
            if (getters.getMode === "free") {
              JsonDataDetail.point = getters.getPoint;
              commit("SET_POINT", JsonDataDetail.point);
            } else {
              commit("SET_POINT", JsonDataDetail.point);
            }
            // console.log(process.env.VUE_APP_KEY, process.env.VUE_APP_SECRET);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getGames: ({ commit }) => {
      return new Promise((resolve, reject) => {
        accessApi()
          .then(async (token) => {
            const headers = { Authorization: `bearer ${token}` };
            const { data } = await apiPortal.get("games", { headers });
            const dataGames = JSON.parse(responseApi(data));
            console.log(dataGames[0].link);

            commit("SET_URL", dataGames[0].link);
            commit("SET_LIST_GAME", dataGames);
            resolve(dataGames);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getPlayerAppData: ({ commit }) => {
      return new Promise((resolve, reject) => {
        accessApi()
          .then(async (token) => {
            const headers = { Authorization: `bearer ${token}` };
            const { data } = await apiPortal.get("getPlayerAppData", {
              headers,
            });
            const dataGames = data.data;
            commit("SET_PLAYER_DATA", dataGames);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getLeaderboard: ({ commit, getters }) => {
      return new Promise((resolve, reject) => {
        accessApi()
          .then(async (token) => {
            const msisdn = toEncrypt(getters.getUser, getters.getSecret);
            const sendData = { req: msisdn };
            const headers = { Authorization: `bearer ${token}` };
            const { data } = await apiPortal.post("gameLeaderboard", sendData, {
              headers,
            });
            const dataLeaderboard = JSON.parse(responseApi(data));
            commit("SET_LEADERBOARD_LIST", dataLeaderboard);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getService: ({ commit }) => {
      return new Promise((resolve, reject) => {
        accessApi()
          .then(async (token) => {
            const headers = { Authorization: `bearer ${token}` };
            const { data } = await apiPortal.get("getTelcoChannel", {
              headers,
            });
            console.log(data.data);
            commit("SET_STORE_LIST", data.data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getInbox: ({ commit, getters }) => {
      accessApi().then(async (token) => {
        const type = toEncrypt(JSON.stringify({ type: 5 }), getters.getSecret);
        const sendData = { req: type };
        const headers = { Authorization: `bearer ${token}` };
        const { data } = await apiPortal.post("gameSet", sendData, { headers });
        const dataGames = JSON.parse(responseApi(data));
        // console.log(dataGames);
        commit("SET_INBOX _LIST", dataGames);
      });
    },
    getBanner: ({ commit, getters }) => {
      accessApi().then(async (token) => {
        const type = toEncrypt(JSON.stringify({ type: 4 }), getters.getSecret);
        const sendData = { req: type };
        const headers = { Authorization: `bearer ${token}` };
        const { data } = await apiPortal.post("gameSet", sendData, { headers });
        const dataGames = JSON.parse(responseApi(data));
        // console.log('data banner',dataGames);
        commit("SET_BANNER_LIST", dataGames);
      });
    },
    getRedeem: ({ commit, getters }) => {
      accessApi().then(async (token) => {
        const type = toEncrypt(JSON.stringify({ type: 3 }), getters.getSecret);
        const sendData = { req: type };
        const headers = { Authorization: `bearer ${token}` };
        const { data } = await apiPortal.post("gameSet", sendData, { headers });
        const dataGames = JSON.parse(responseApi(data));
        // console.log(dataGames);
        commit("SET_REDEEM_LIST", dataGames);
      });
    },
    getStore: ({ commit, getters }) => {
      accessApi().then(async (token) => {
        const type = toEncrypt(JSON.stringify({ type: 2 }), getters.getSecret);
        const sendData = { req: type };
        const headers = { Authorization: `bearer ${token}` };
        const { data } = await apiPortal.post("gameSet", sendData, { headers });
        const dataGames = JSON.parse(responseApi(data));
        // console.log(dataGames);
        commit("SET_STORE_LIST", dataGames);
      });
    },
    getReward: ({ commit, getters }) => {
      accessApi().then(async (token) => {
        const type = toEncrypt(JSON.stringify({ type: 1 }), getters.getSecret);
        const sendData = { req: type };
        const headers = { Authorization: `bearer ${token}` };
        const { data } = await apiPortal.post("gameSet", sendData, { headers });
        const dataGames = JSON.parse(responseApi(data));
        // console.log(dataGames);
        commit("SET_REWARD_LIST", dataGames);
      });
    },
    getGameReward: ({ commit }) => {
      accessApi().then(async (token) => {
        const headers = { Authorization: `bearer ${token}` };
        const { data } = await apiPortal.get("gameReward", { headers });
        const res = responseApi(data);
        const dataReward = JSON.parse(res);
        // console.log(dataReward);
        commit("SET_REWARD", dataReward);
      });
    },
    getLife: ({ commit, getters }) => {
      return new Promise((resolve, reject) => {
        accessApi()
          .then(async (token) => {
            const unix = Math.round(+new Date() / 1000);
            const unixSlice = unix.toString().slice(1, 10);
            const gameUnix = getters.getGameId + parseInt(unixSlice);
            const datas = {
              game_id: gameUnix,
              msisdn: getters.getUser,
              type: "standalone",
            };
            // console.log('data dikirim', datas);
            const request = toEncrypt(JSON.stringify(datas), getters.getSecret);
            const sendData = { req: request };
            const headers = { Authorization: `bearer ${token}` };
            const { data } = await apiPortal.post("gameLife", sendData, {
              headers,
            });
            const dataLife = await JSON.parse(responseApi(data));
            commit("SET_TOKEN_LIFE", dataLife.token_life);
            commit("SET_GAME_ID_UNIX", gameUnix);
            // console.log('getlife',dataLife);
            resolve(dataLife.token_life);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getLifeSubs: ({ commit, getters }) => {
      return new Promise((resolve, reject) => {
        accessApi()
          .then(async (token) => {
            const payload = {
              msisdn: toEncrypt(getters.getUser, getters.getSecret),
            };

            const headers = { Authorization: `bearer ${token}` };
            const { data } = await apiMsg.post("get-life", payload, {
              headers,
            });

            const responseData = data && data.data ? data.data : data;
            const lifeId = responseData && responseData.life_id;
            const gameId = responseData && responseData.game_id;

            if (!lifeId || !gameId) {
              reject(new Error("Life data not found in response"));
              return;
            }

            commit("SET_TOKEN_LIFE", lifeId);
            commit("SET_GAME_ID_UNIX", gameId);
            resolve(lifeId);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    setPlayerData: async ({ commit }, datap) => {
      return new Promise((resolve, reject) => {
        accessApi()
          .then(async (token) => {
            const datas = datap;
            const headers = { Authorization: `bearer ${token}` };
            const { data } = await apiPortal.post(
              "updatePlayerAppData",
              datas,
              { headers },
            );
            const dataPlayer = data.data;
            commit("SET_PLAYER_DATA", dataPlayer);

            resolve(dataPlayer);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    storePoint: async ({ commit, getters }, point) => {
      return new Promise((resolve, reject) => {
        accessApi()
          .then(async (token) => {
            const cappedPoint = point.map((item) => ({
              ...item,
              point: item.point > 10 ? 10 : item.point,
            }));

            const datas = {
              game_id: getters.getGameIdUnix,
              msisdn: getters.getUser,
              token_id: getters.getLifeId,
              data: cappedPoint,
            };
            // console.log("store data", datas);
            const request = toEncrypt(JSON.stringify(datas), getters.getSecret);
            const sendData = { req: request };
            const headers = { Authorization: `bearer ${token}` };
            const { data } = await apiPortal.post("gamePoint", sendData, {
              headers,
            });
            const dataPoint = await JSON.parse(responseApi(data));
            // console.log('response store', dataPoint)
            commit("SET_DATA_POINT", dataPoint);
            resolve(dataPoint);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    storePointGo: async ({ commit, getters }, point) => {
      return new Promise((resolve, reject) => {
        accessApi()
          .then(async (token) => {
            const cappedPoint = point.map((item) => ({
              ...item,
              point: item.point > 10 ? 10 : item.point,
            }));

            const unix = Math.round(+new Date() / 1000);
            const unixSlice = unix.toString().slice(1, 10);

            const datas = {
              game_id: getters.getGameIdUnix,
              msisdn: getters.getUser,
              token_id:
                getters.getLifeId == null
                  ? getters.getGameId + parseInt(unixSlice)
                  : getters.getLifeId,
              data: cappedPoint,
            };
            console.log("store data", datas);

            const request = toEncrypt(JSON.stringify(datas), getters.getSecret);
            const sendData = { req: request };
            const headers = { Authorization: `bearer ${token}` };
            const { data } = await apiMsg.post("game/point", sendData, {
              headers,
            });
            const dataPoint = await JSON.parse(responseApi(data));
            commit("SET_DATA_POINT", dataPoint);
            resolve(dataPoint);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deliverRecipe: ({ commit }, datap) => {
      return new Promise((resolve, reject) => {
        accessApi()
          .then(async () => {
            // let urldr= "dr?trx_id=313135353634393433383737&op_id=1&keyword="+datap.marketid+"&msisdn="+datap.msisdn+"&adn=90009&date="+datap.date+"&status=SUCCESS&subject=MT;PULL;SMS;TEXT"
            let urldr =
              "charging?adn=90009&msisdn=" +
              datap.msisdn +
              "&keyword=" +
              datap.marketid +
              "&type=pull&channel=gplay";
            const { data } = await apiDPA.post(urldr);
            commit("SET_DELIVER_RECHIVE", data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getSubscriptionStatusByFakeId: ({ commit, getters }) => {
      return new Promise((resolve, reject) => {
        const sendData = { fake_id: getters.getPid, app_id: 16 };
        apiPortal
          .post("getSubscriptionStatusByFakeId", sendData)
          .then(async (response) => {
            const dataUser = response.data.data;
            commit("SET_USER", String(dataUser.msisdn));
            commit("SET_MNO_ID", String(dataUser.mno_id));
            commit("SET_TELCO", "smart");
            resolve(dataUser);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getSubscriptionStatusByFakeId2: ({ commit, getters }) => {
      return new Promise((resolve, reject) => {
        const sendData = { fake_id: getters.getPid, app_id: 16 };
        apiPortal
          .post("getSubscriptionStatusByFakeId", sendData)
          .then(async (response) => {
            const dataUser = response.data.data;
            commit("SET_USER", String(dataUser.msisdn));
            commit("SET_MNO_ID", String(dataUser.mno_id));
            resolve(dataUser);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  modules: {
    // login
  },
});
